import BackendService from 'BackendService';
import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import type Investor from '../../../models/Investor';
import StyledSection from '../../styles/StyledSection';
import {
  createFundOpportunityPreviewHandlers,
  type FundOpportunityPreviewService,
} from '../investorPreview/contentPreviewHandlers';
import InvestorPreviewFrame from '../investorPreview/InvestorPreviewFrame';
import MobileAppPreview from '../MobileAppPreview';
import { ContentEditorPreviewPanelsProps } from './newContentManagementEditorTypes';

/** Stands in for an investor when the editor has no real one to preview as. */
const PLACEHOLDER_INVESTOR = {
  id: 'preview',
  contactId: 'preview',
  status: 'OPPORTUNITY',
  updatedAt: new Date(0).toISOString(),
} as unknown as Investor;

export default function ContentEditorPreviewPanels({
  pageMode,
  content,
  fundOpportunity,
  previewInvestor,
}: ContentEditorPreviewPanelsProps) {
  const handlers = useMemo(
    () =>
      createFundOpportunityPreviewHandlers(
        new BackendService() as unknown as FundOpportunityPreviewService,
      ),
    [],
  );

  if (pageMode === 'preview-app') {
    return (
      <Box sx={{ mb: 3 }}>
        <StyledSection tone="tone1">
          <MobileAppPreview content={content.content} fundOpportunity={fundOpportunity} />
        </StyledSection>
      </Box>
    );
  }

  if (pageMode !== 'preview-web') {
    return null;
  }

  return (
    <InvestorPreviewFrame
      view="fund-opportunity-eoi"
      viewProps={{
        fundOpportunity,
        content,
        investor: previewInvestor ?? PLACEHOLDER_INVESTOR,
      }}
      handlers={handlers}
      title="Fund opportunity as investors see it"
    />
  );
}
